
import KPaginatedAutocomplete from "@/components/crud/fields/KPaginatedAutocomplete.vue";
import Vue from "vue";
import { clientAutocomplete } from "@/modules/client/api/clients";

export default Vue.extend({
  name: "ClientAutocomplete",
  components: { KPaginatedAutocomplete },
  methods: {
    clientAutocomplete,
  },
});
